import { render, staticRenderFns } from "./MiniGames.vue?vue&type=template&id=22bb5495&scoped=true"
import script from "./MiniGames.vue?vue&type=script&lang=js"
export * from "./MiniGames.vue?vue&type=script&lang=js"
import style0 from "./MiniGames.vue?vue&type=style&index=0&id=22bb5495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb5495",
  null
  
)

export default component.exports